module.exports = __webpack_public_path__ + "img/applicable-4.b7d2bc36.png";